import $ from 'jquery';
import {ISocketData} from "../../../interface";

const BASE_SELECTOR: string = "[data-gameserverstatus]"
const CPU_SELECTOR: string = "[data-cpu]";
const RAM_SELECTOR: string = "[data-ram]";
const REINSTALL_SELECTOR: string = "[data-reinstall]";

export class GameserverStatusUI {
  /**
   * variable to control the fixed-point notation of RAM
   */
  readonly RAM_USAGE_FIXED_NOTATION = 0;

  public constructor(private $base: JQuery) {
  }

  public disableReinstallButton(state: boolean) {
    if (state) {
      this.$base.find(REINSTALL_SELECTOR).attr("disabled", "disabled");
    } else {
      this.$base.find(REINSTALL_SELECTOR).removeAttr("disabled");
    }
  }

  public onReinstallClick(callback: (url: string) => {}) {
    this.$base.find(REINSTALL_SELECTOR).on('click', () => {
      callback(this.$base.find(REINSTALL_SELECTOR).data("url"));
    });
  }

  /**
   * Update the CPU progressbar
   * @param data
   */
  public renderCPU(data: ISocketData) {
    let percent = Number(data.cpuTotal);
    if (isNaN(percent)) {
      percent = 0;
    }

    $(CPU_SELECTOR).prev().text(percent.toFixed(2).toString() + "%");
    $(CPU_SELECTOR).find('.progress__bar').width(percent.toFixed(2) + '%')
  }

  /**
   * Update the RAM progressbar
   * @param data
   */
  public renderRAM(data: ISocketData) {
    let used : number = 0;
    const element : JQuery = $(RAM_SELECTOR);

    if (typeof data.memory !== 'undefined') {
      used = data.memory.used / 1024 / 1024;
    }

    const total : number = Number(this.$base.data('max-memory'));

    let percentage = 100 / total * used;

    if (isNaN(percentage)) {
      percentage = 0;
    }

    if (element.is('[data-show-max-ram]')) {
      element.prev().text(`${used.toFixed(this.RAM_USAGE_FIXED_NOTATION)} MB / ${total} MB`);
    } else {
      element.prev().text(`${used.toFixed(this.RAM_USAGE_FIXED_NOTATION)} MB`);
    }

    element
      .find('.progress__bar')
      .width(
        percentage.toFixed(this.RAM_USAGE_FIXED_NOTATION) + '%'
      );
  }

  /**
   * return the service id
   */
  public getServiceId(): number {
    return this.$base.data('service-id');
  }
}

export function createGameserverStatusUI(): GameserverStatusUI[] {
  const $base = $(BASE_SELECTOR);
  let instances: GameserverStatusUI[] = [];
  $base.each((index, el) => {
    instances.push(new GameserverStatusUI($(el)))
  });

  return instances;
}
